module.exports = __webpack_public_path__ + "img/Guirlandes_lumineuses_de_mariage.2401c04.jpg";